const IRTypes = {
    IR_ADD_DATA: "IR_ADD_DATA",
    IR_ADD_COMPANY: "IR_ADD_COMPANY",
    IR_FETCH_DATA:"IR_FETCH_DATA",
    IR_FETCH_DATA_FAILED:"IR_FETCH_DATA_FAILED",
    IR_ACTION_START:"IR_ACTION_START"
}


const Initial_state = {
    loading:false,
    isSuccess: false,
    response: []
}

const IRReducer = (state=Initial_state, action) => {
    switch(action.type){
        case IRTypes.IR_ADD_DATA:{
            return {
                ...state, 
                checkData: action.payload
            };
        }
        case IRTypes.IR_ADD_COMPANY: {
            return {
                ...state,
                companyData: action.payload
            }
        }
        case IRTypes.IR_ACTION_START:
            return {
                ...state,
                loading: true,
            }

        case IRTypes.IR_FETCH_DATA: 
        return {
            ...state,
            loading: false,
            isSuccess: true,
            response: action.payload.data,
            set_payload: action.payload.data
        }
        case IRTypes.IR_FETCH_DATA_FAILED: 
            return {
                ...state,
                loading: false,
                isSuccess: false,
                error: action.payload
            }
        default:
            return {...state}
    }
}

export default IRReducer;